module.exports = __webpack_public_path__ + "static/img/10.0ea6e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/new/10.png
// module id = E7Jl
// module chunks = 0